module.exports = __webpack_public_path__ + "d399804e2d6445eeeb8befbc9d5912ee.png";


//////////////////
// WEBPACK FOOTER
// ./shared/images/header/truck.png
// module id = 974
// module chunks = 2